import wx from 'jweixin-module';
import { getMapSdk } from '@/api/api-ticket.js';

/*
 * 判断是否IOS环境
 * */
export function isIOS() {
  const isIphone = navigator.userAgent.includes('iPhone')
  const isIpad = navigator.userAgent.includes('iPad')
  console.log(navigator.userAgent)

  return isIphone || isIpad
}

/*
 * 获取微信签名，注入权限验证配置
 * */
export function requestWxStr() {
  const params = {
    'path': '/yx_yun_jing_tong_ticketing_client_mobile/?spot_id=1'
  }
  getMapSdk(params).then(res=>{
    wx.config(res);
  })
}
